import {ChevronLeft,ChevronRight} from "lucide-react";
import React from "react";
import {getDirection} from "../../../config/design/theme";

const ChevronForward = ({className}) => {
  let dir = getDirection();

  return (
      dir === "rtl" ?
          <ChevronLeft className={className}/>
          :
          <ChevronRight className={className}/>
  );
};

export default ChevronForward;
